/**
 * Update date: 08-06-2023
 * Datagrid component
 */

import DataGridSimple from './DataGridSimple';
import DataGridFull from './DataGrid';

export { DataGridSimple, DataGridFull };
